<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}

i.fas {
  display: inline-block;
  padding: 0.5em 0.8em;
  border: 1px solid #d4d6db;
  border-radius: 100%;
  margin: 0.1em;

  &.fa-male {
    &.selected {
      color: $male;
      border-color: $male;
    }
  }

  &.fa-female {
    &.selected {
      border-color: $female;
      color: $female;
    }
  }
}
</style>
<template>
  <td class="text-center">
    <i class="fas fa-male fa-sm" :class="{ selected: isGender('Mann') }"></i>
    <i class="fas fa-female fa-sm" :class="{ selected: isGender('Frau') }"></i>
  </td>
</template>
<script>
export default {
  data() {
    return {
      genders: []
    };
  },
  created() {
    this.genders = this.content;
  },
  props: {
    content: {
      required: true
    }
  },
  methods: {
    isGender(value) {
      return this.genders.includes(value);
    }
  }
};
</script>
